import React from "react";
import Fade from "react-reveal/Fade";

import medal from "../../images/medal.png";
import mission from "../../images/mission.png";
import diamond from "../../images/value.png";
import featuresBg from "../../images/features-bg-01.png";

import "./style.css";
import texts from "../../texts.json";

const FeaturesComponent = (props) => {
  const index = props.index;

  return (
    <div className="section features-section">
      <img src={featuresBg} className="features-bg" alt="" />

      <div className="section-content features-content">
        <Fade bottom>
          <div className="one-feature">
            <div className="feature-medal">
              <img alt="Mission" src={mission} />
            </div>
            <p className="feature-title">
              {texts.features.titles.missao[index]}
            </p>

            <p className="feature-text">{texts.features.missao[index]}</p>
          </div>

          <div className="one-feature">
            <div className="feature-medal mission">
              <img alt="Tradition" src={diamond} className="mission-img" />
            </div>
            <p className="feature-title">{texts.features.titles.tradicao[index]}</p>

            <p className="feature-text">{texts.features.tradicao[index]}</p>
          </div>

          <div className="one-feature">
            <div className="feature-medal">
              <img alt="Quality" src={medal} />
            </div>
            <p className="feature-title">
              {texts.features.titles.qualidade[index]}
            </p>

            <p className="feature-text">{texts.features.qualidade[index]}</p>
          </div>
        </Fade>
      </div>
    </div>
  );
};

export default FeaturesComponent;
